module.exports = __webpack_public_path__ + "static/savantPowerLogo-ce51e71945c7ccb99dbddbce8a179955.png";